import _ from 'lodash';

export const QueryConf = {
  get: (list, filter, search, filterConf, searchConf, userAuth) => {
    const { pagination, sort } = list;
    const { value: searchValue } = search;
    const { value: filterValue } = filter;
    const userDepartment = userAuth?.department;

    const customFilterConf = _.get(filterConf, userDepartment) || filterConf?.DEFAULT;

    return {
      pagination: { ...pagination },
      sort: _.isArray(sort)
        ? sort?.map((item) =>
          _.setWith({}, [...item?.by.split('.')], item.direction, Object)
        )
        : `${sort.by}:${sort.direction}`,
      filters: {
        $or: searchConf?.query?.keys?.map(({ key, operator }) =>
          _.setWith(
            {},
            _.chunk([...key.split('.'), operator]),
            searchValue,
            Object
          )
        ),
        $and: customFilterConf?.query?.keys?.map(({ key, operator, value }) => {
          const newValue = _.get(filterValue, _.head(_.split(value, '.')));

          if (_.isArray(newValue)) {
            return {
              $or: newValue.map((item) => {
                return item?.id === null
                  ? _.setWith(
                    {},
                    _.chunk([...key.split('.'), '$null']),
                    true,
                    Object
                  )
                  : _.setWith(
                    {},
                    _.chunk([...key.split('.'), operator]),
                    _.get(item, _.last(_.split(value, '.'))),
                    Object
                  );
              }),
            };
          } else {
            return newValue?.id === null
              ? { [key]: { $null: true } }
              : _.setWith(
                {},
                _.chunk([...key.split('.'), operator]),
                _.get(filterValue, value),
                Object
              );
          }
        }),
      },
    };
  },
};
